module.exports = __webpack_public_path__ + "img/spirit_light_grey_ba_detail_rsh_1.57f6870c.jpg";